import { createStore } from 'redux';
import root from './reducers/root';

export default createStore(root);
